<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>
<div class="row" style="margin-bottom: 5px;">
  <div class="d-flex justify-content-end p-3">

    <div class="d-flex gap-3">
      <div class="d-flex gap-3 pull-right button-continer">
        <div class="d-flex gap-3" *ngFor="let button of buttonLabels">
          <span class="button-continer" *ngIf="buttonLabels != ''">
            <button *ngIf="button != 'Cancel' && button != ''" class="addIconContiner text-white px-4 reload_text"
              (click)="dynamicButtonClick(button)">
              {{button}}
            </button>
          </span>
        </div>
        <div *ngIf="!formTemplateData.isAddForm" class="d-flex gap-3">
          <span class="button-continer">
            <button class="addIconContiner text-white px-4 reload_text" (click)="openFormTemplateFields()">
              <i class="fa fa-edit"></i>Form Fields
            </button>
          </span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="backToFormTemplate()">
          Cancel
        </button>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="instructions !=null">
    <p style="text-align: right;margin-bottom:0px;"><i>{{instructions}}</i></p>
  </div>
</div>
<div class="table-container">

  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div class="form-template">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container" style="padding-bottom: 5px;">
          <span class="gridName">Form Template</span>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="dynamicLabel">
      <div class="col-md-4">
        <!-- Template Name -->
        <div><label for="email">{{dynamicLabel['TEMPLATE_NAME']}}</label><span class="mandatory-symbol">*</span></div>
        <input id="templateName" class="input-filed-continers" type="text" [(ngModel)]="formTemplateData.templateName"
          [disabled]="!saveButtonForTemplate">
        <span id="templateName-required-msg">Please enter the template Name</span>
      </div>
      <div class="col-md-2">
        <!-- Status -->
        <div><label for="email">{{dynamicLabel['STATUS']}}</label></div>
        <input id="templateName" class="input-filed-continers" type="text" [(ngModel)]="formTemplateData.status"
          disabled>
      </div>
      <div class="col-md-2">
        <!-- Stages -->
        <div><label for="email">{{dynamicLabel['LIST_OF_STAGES']}}</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #stages [(ngModel)]="selectedStages"
          (closed)="stagesSearchText=''" id="stageName" [disabled]="!saveButtonForTemplate"
          (click)="focusSearch('stagesfocus')">
          <input type="search" id="stagesfocus" class="dropdownsearchstyle" [(ngModel)]="stagesSearchText" matInput
            placeholder="Search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="isStagesSelected" (change)="toggleAllSelection('stages')">Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item1 of stagesDropdown | multiAssessmentSearchPipe :stagesSearchText"
            [value]="item1.valueExp" (onSelectionChange)="onStageSelect($event, item1)">
            {{ item1.displayExp }}
          </mat-option>
        </mat-select>
        <span id="stageName-required-msg">Please select stage</span>
      </div>
      <div class="col-md-4">

        <div>
          <!-- Approver -->
          <label for="email">
            {{ dynamicLabel['APPROVED_USER_BY_USER'] }}
          </label> <label for="email" *ngIf="message.showSwitchUser && formTemplateData.status !='Approved'">
            <a (click)="openSwitchUser('Approver')">
              <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                height="25">
            </a>
          </label>
        </div>
        <mat-select matInput placeholder="Select" id="stageName"
          [ngClass]="{'odd-item-mat-select': oddApprover == selectedApprover}" [disabled]="!saveButtonForTemplate"
          [(ngModel)]="selectedApprover" (closed)="approversearchTxt=''" (click)="focusmethod('approverfocusSearch')">
          <input type="search" id="approverfocusSearch" class="dropdownsearchstyle" [(ngModel)]="approversearchTxt"
            matInput placeholder="Search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of approverDropdown | assessmentSearch :approversearchTxt"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

    </div>
    <div class="row" *ngIf="dynamicLabel">
      <div class="col-md-2">
        <!-- Allow To Add New Form -->
        <div><label for="isMand">{{dynamicLabel['ALLOW_TO_ADD_NEW_FORM']}}</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="formTemplateData.allowToAddNewForm1"
          [disabled]="!saveButtonForTemplate">
          <span class="active-inActive-container" *ngIf="formTemplateData.allowToAddNewForm1==true"
            [ngStyle]="formTemplateData.allowToAddNewForm1 == true?{'color':'green'} : {'color': ''}">Yes</span>
          <span *ngIf="formTemplateData.allowToAddNewForm1==false"
            [ngStyle]="formTemplateData.allowToAddNewForm1 == false?{'color':'red'} : {'color': ''}">No</span>
        </mat-slide-toggle>
      </div>
      <div class="col-md-2" *ngIf="formTemplateData.approvalRequestedOn !=null">
        <!-- Approval Requested On -->
        <div><label for="email">{{dynamicLabel['APPROVAL_REQUESTED_ON']}}</label></div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
            [dateCustomClasses]="dateCustomClasses" disabled [(ngModel)]="formTemplateData.approvalRequestedOn">
        </div>
      </div>
      <div class="col-md-2" *ngIf="formTemplateData.approvedOn !=null">
        <div><label for="email">
            {{ dynamicLabel['APPROVED_ON'] }}
          </label></div>
        <div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
            [dateCustomClasses]="dateCustomClasses" disabled [(ngModel)]="formTemplateData.approvedOn">
        </div>
      </div>
      <div class="col-md-4" *ngIf="formTemplateData.approverComments != null">
        <!-- Approver Comments -->
        <div><label for="email">{{dynamicLabel['APPROVER_COMMENTS']}}</label></div>
        <input id="templateName" class="input-filed-continers" type="text"
          [(ngModel)]="formTemplateData.approverComments" disabled>
      </div>
    </div>
    <div class="row" *ngIf="dynamicLabel">
      <div class="col-md-2">
        <!-- Created On -->
        <div><label for="email">{{dynamicLabel['CREATED_ON']}}</label></div>
        <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
          [dateCustomClasses]="dateCustomClasses" disabled [(ngModel)]="formTemplateData.createdOn">
      </div>
      <div class="col-md-2">
        <!-- Created By -->
        <div><label for="email">{{dynamicLabel['CREATED_BY_USER']}}</label></div>
        <input id="templateName" class="input-filed-continers" type="text" [(ngModel)]="formTemplateData.createdByUser"
          disabled>
      </div>
      <div class="col-md-8">
        <!-- Template Description -->
        <div><label for="email">{{dynamicLabel['TEMPLATE_DESCRIPTION']}}</label></div>
        <textarea class="textarea-filed-continers" type="text" [(ngModel)]="formTemplateData.templateDescription"
          [disabled]="!saveButtonForTemplate"></textarea>
      </div>
      <div class="col-md-4" *ngIf="saveButtonForTemplate">
        <!-- Template Name -->
        <div><label for="email " id="update-validation">{{dynamicLabel['UPDATE_REASON']}}</label><span
            class="mandatory-symbol">*</span></div>
        <textarea id="update" rows="4" class="textarea-filed-continers" type="text"
          [(ngModel)]="formTemplateData.updateReason"></textarea>
        <span id="update-required-msg">Please enter update reason</span>
      </div>
    </div>
    <br><br>
    <div class="button-continer" mat-dialog-actions class="btn-align" *ngIf="saveButtonForTemplate">
      <button mat-stroked-button class="addButton" (click)="updateFormTemplate(formTemplateData)">
        <i class="fas fa-user-edit"></i> Update
      </button>
    </div>
  </div>
</div>
<br>

<div class="row" [hidden]="formTemplateData.isAddForm">
  <div class="col-md-12">
    <mat-tab-group mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4" animationDuration="0ms"
      (selectedTabChange)="onTabChanged($event);">
      <mat-tab label="Sections">
        <ng-template mat-tab-label>
          <span>Sections</span>
        </ng-template>
        <app-form-section-template [data]="formTemplateData"></app-form-section-template>
      </mat-tab>
      <mat-tab label="Users">
        <ng-template mat-tab-label>
          <span>Users</span>
        </ng-template>
        <app-form-template-users [data]="formTemplateData"></app-form-template-users>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<div class="row" [hidden]="!formTemplateData.isAddForm">
  <div class="col-md-12">
    <app-forms [data]="formTemplateData"></app-forms>
  </div>
</div>
<ng-template #fieldPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelFieldPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Form Template Fields</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="row">
      <app-form-template-fields [data]="formTemplateData"></app-form-template-fields>
    </div>
  </div>
</ng-template>

<ng-template #performOperation>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelOperationFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row" [hidden]="title!='Send for Approval'" style="margin-bottom: 8%;">
        <div class="col-md-10">
          <div><label for="email">Approver</label><span class="mandatory-symbol">*</span></div>
          <!-- <ng-multiselect-dropdown  id="approver" style="position: absolute;width: 75%;"
                        class="multiselect-container" [(ngModel)]="selectedApprover"
                        [settings]="singleSelectDropdownSetting" [data]="approverDropdown">
                    </ng-multiselect-dropdown> -->
          <mat-select matInput placeholder="Select" id="approver"
            [ngClass]="{'odd-item-mat-select': oddApprover == selectedApprover}" [(ngModel)]="selectedApprover"
            (closed)="approversearchTxt=''" (click)="focusmethod('sendapproverfocusSearch')">
            <input type="search" id="sendapproverfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="approversearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of approverDropdown | assessmentSearch :approversearchTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span style="margin-top: 10%;" id="approver-required-msg">Please select the approver</span>
        </div>
      </div>
      <div class="row" [hidden]="title != 'Approve'">
        <div class="col-md-10">
          <div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
          </div>
          <div> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="displayUserName" disabled>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!isAdenabled" [hidden]="(title != 'Approve' )">
        <div class="col-md-10">
          <div><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
          <div> <input id="password" style="height: 80% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
          <span id="password-required-msg">Please enter password</span>
        </div>
      </div>
      <div class="row" [hidden]="title == 'Send for Approval'">
        <div class="col-md-12">
          <div><label for="email">Comments</label><span class="mandatory-symbol">*</span></div>
          <textarea id="comments" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="comments"></textarea>
          <span id="comments-required-msg">Please provide the comments</span>
        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="deleteButton" (click)="perfomrOpernFunc()">
        {{title}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelOperationFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Warning</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        {{ warningMsg }}
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="okInfo()">
        OK
      </button>
    </div>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>